import React from 'react';
import { ReadyState } from 'react-use-websocket';
import { SendJsonMessage } from 'react-use-websocket/dist/lib/types';
import { AudioWebhookResponse } from '../../SessionConnectionContextProvider/useSessionConnectionContext';

interface AudioWebsocketApiConnectionContextProps {
  lastJsonMessage: AudioWebhookResponse | null;
  sendJsonMessage: SendJsonMessage;
  sendMessage: (message: Uint8Array, index: number) => void;
  readyState: ReadyState;
  restart(): void;
}

export const AudioWebsocketApiConnectionContext = React.createContext<AudioWebsocketApiConnectionContextProps | null>(null);

export default function useAudioWebsocketApiConnectionContext() {
  const context = React.useContext(AudioWebsocketApiConnectionContext);
  if (context === null) {
    throw new Error('useAudioWebsocketApiConnectionContext must be used within a AudioWebsocketApiConnectionContextProvider');
  }
  return context;
}
